import { GoogleApi } from '@/api/google';
import { useQuery } from '@tanstack/react-query';
import { googleKeys } from './google.keys';

export function useOauthStatus(options?: { enabled?: boolean }) {
  const enabled = options?.enabled ?? true;
  return useQuery({
    queryKey: googleKeys.oauthStatus(),
    queryFn: GoogleApi.getOauthStatus,
    enabled,
  });
}
